<template>
    <div class="shopping-cart-list">
        <div class="valid-list">
            <goods-item v-for="(item, index) in validCartList" :productInfo="item" :key="item.productId"></goods-item>
        </div>
        <div class="invalid-list" v-if="invalidCartList.length > 0">
            <h4 class="title">
                <span class="title-text">失效商品</span>
                <span class="clear" @click="event_clearInvalidProducts">
                    全部清空&nbsp;<i class="iconfont icon-qingchulishi"></i>
                </span>
            </h4>
            <div class="bottom-line"></div>
            <div class="content">
                <invalid-goods-item v-for="item in invalidCartList" :productInfo="item" :key="item.productId"></invalid-goods-item>
            </div>
        </div>
    </div>
</template>

<script>
    import GoodsItem from '@/components/GoodsItem';
    import InvalidGoodsItem from '@/components/InvalidGoodsItem';

    import {mapGetters, mapMutations, mapActions} from 'vuex';

    import {handleResCartData} from '@/public/js/public.js';

    import {api_deleteProduct} from '@/api';

    export default {
        name: '',
        components: {
            GoodsItem,
            InvalidGoodsItem
        },
        computed: {
            ...mapGetters([
                'cartData',
                'validCartList',
                'invalidCartList'
            ])
        },
        methods: {
            ...mapActions(['showConfirm']),
            // 清空失效商品
            event_clearInvalidProducts () {
                this.showConfirm({
                    content: '确认要清空所有失效商品吗？',
                    ok: () => {
                        const _this = this;

                        let itemKeysArr = [], itemKeys;
                        _this.invalidCartList.forEach(item => {
                            itemKeysArr.push(item.itemKey);
                        });

                        itemKeys = itemKeysArr.join(',');

                        api_deleteProduct(itemKeys).then(({data}) => {
                            const {retCode, cart} = data;

                            if (retCode === 0) {
                                handleResCartData(cart);
                            }
                        });
                    }
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
.shopping-cart-list {

    .invalid-list {
        /*padding: 0 toRem(30);*/
        margin-bottom: toRem(20);
        background-color: $color-white;
        /*box-shadow: 0 1px 0 0 #E1E1E1;*/
        @include border-1px-b(#E1E1E1);
        overflow: hidden;

        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: toRem(30) toRem(30);
            span {
                display: block;
            }
            .title-text {
                font-family: PingFangSC-Medium;
                font-size: toRem(30);
                line-height: toRem(42);
                color: #1C1717;
            }
            .clear {
                font-family: PingFangSC-Light;
                font-size: toRem(26);
                line-height: toRem(37);
                color: #1C1717;
                .iconfont {
                    font-size: toRem(28);
                }
            }
        }

        .bottom-line {
            width: toRem(690);
            /*height: 1px;*/
            margin: 0 auto;
            @include border-1px-b($color-gray);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ShoppingCartList/index.vue